<script setup lang="ts">
import { CardAdmin } from '@shared/ui/cards'

import { useExtraRatesStore } from '../../model/extra-rates/store'
import BtnExtraRatesSave from './BtnExtraRatesSave.vue'
import SectionExtraRatesTable from './SectionExtraRatesTable.vue'
import SlotsDaysHeader from '../slots/SlotsDaysHeader.vue'

defineOptions({
  name: 'SectionExtraRatesBody',
})

const extraRatesStore = useExtraRatesStore()

const refTabs = computed(() => extraRatesStore.getDaysOfWeek.map(day => ({
  id: day.day_of_week,
  point: extraRatesStore.getSlotsWithEnabledExtraRates(day.day_of_week),
})))
</script>

<template>
  <CardAdmin
    title="Extra rates control"
    fullwidth
  >
    <template #header>
      <BtnExtraRatesSave />
    </template>
    <SlotsDaysHeader
      :tabs="refTabs"
      :selected="extraRatesStore.getTabId"
      @select="extraRatesStore.setTabId"
    />
    <SectionExtraRatesTable
      v-for="day in extraRatesStore.getDaysOfWeek"
      :id="day.day_of_week"
      :key="day.day_of_week"
      :show="day.day_of_week === extraRatesStore.getTabId"
    />
  </CardAdmin>
</template>
